import { render, staticRenderFns } from "./bindWechat.vue?vue&type=template&id=e520f4a2&"
import script from "./bindWechat.vue?vue&type=script&lang=js&"
export * from "./bindWechat.vue?vue&type=script&lang=js&"
import style0 from "./bindWechat.vue?vue&type=style&index=0&id=e520f4a2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports